import React, { useEffect, useState } from "react";
import Shopsubbanner from "../../components/shopsubbanner";
import ProductGrid from "../../components/ProductGrid";

const Candy = ({ products, loading, error }) => {
  const [bannerImage, setBannerImage] = useState(
    "https://res.cloudinary.com/dtivafy25/image/upload/v1753965698/VitaCin_ipp5do.png"
  );

  useEffect(() => {
    window.scrollTo(0, 0);

    const updateBanner = () => {
      if (window.innerWidth <= 768) {
        // Mobile banner
        setBannerImage("https://res.cloudinary.com/dtivafy25/image/upload/v1754651194/04_stclh1.jpg");
      } else {
        // Desktop banner
        setBannerImage("https://res.cloudinary.com/dtivafy25/image/upload/v1753965698/VitaCin_ipp5do.png");
      }
    };

    updateBanner(); // Run on mount
    window.addEventListener("resize", updateBanner);

    return () => {
      window.removeEventListener("resize", updateBanner);
    };
  }, []);

  return (
    <>
      <Shopsubbanner image_url={bannerImage} />
      <ProductGrid category="Candy" products={products} loading={loading} error={error} />
    </>
  );
};

export default Candy;
